const cartQuantityHandler = () => {
    document.querySelector('.woocommerce-cart')?.addEventListener('change', (event) => {
        const submitButton = document.querySelector('button[name="update_cart"]')
        if (event.target.classList.contains('qty') && submitButton) {
            setTimeout(() => {
                submitButton.click()
            }, 500)
        }
    })
}

export default (function () {
    cartQuantityHandler()
})
